export default "__VITE_ASSET__BBj81Qw5__"